class ScrollTo extends HTMLElement {
  constructor() {
    super();
    this.targetId = this.getAttribute('data-target');
  }

  connectedCallback() {
    this.addEventListener('click', this.handleScroll.bind(this));
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleScroll.bind(this));
  }

  handleScroll(event) {
    event.preventDefault();
    const targetElement = document.getElementById(this.targetId);

    if (targetElement) {
      targetElement.scrollIntoView({
          behavior: 'smooth'
      });
    }
  }
}

// Define the custom element
customElements.define('scroll-to', ScrollTo);
